// extracted by mini-css-extract-plugin
export default {"bold":"DefaultDescription-module__bold__12kRN"};